import React, { useMemo } from 'react';
import { Dialog, DialogActions, Button } from '@mui/material';
import * as columns from '../../misc/Columns.ts';
import { NewOrEdit } from '../NewOrEdit.tsx';
import { MonitoringData } from './MonitoringData.tsx';
import { useSnackbarMessage } from '../SnackMessge.tsx';
import { LovInfoDictionary } from '../../misc/LovInfoDictionary.tsx';
import { useState } from 'react';
import * as common from './Common.ts';
import * as frac_api from "../../api/FracApi.ts";
import * as columns_info from '../../misc/Columns.ts';

export function ResistanceDataPageEdit({
    columns,
    showEdit,
    editData,
    onHandleClose,
    onHandleChangedData,
    onHandleUpdatePressed,
    lovs
}: {
    columns: columns.ColumnInfo[],
    showEdit: boolean,
    onHandleClose: () => void,
    editData: MonitoringData,
    onHandleChangedData: (changedData: MonitoringData) => void,
    onHandleUpdatePressed: (rec: frac_api.ResistanceData) => void,
    lovs: LovInfoDictionary,
}) {

    const [isLoding, setIsLoading] = useState(true);
    const { showMessage } = useSnackbarMessage();
    const [isEditing, setIsEditing] = useState(false);

    const newColumns = useMemo<columns_info.ColumnInfo[]>(() => {

        var columnsCopy = columns.map((col) => {
            return { ...col };
        });

        const countryCol = columnsCopy.find((col) => col.id === "country");
        if (countryCol) {
            countryCol.multi = false;

        } else {
            showMessage("Inernal error, please contact support.");
        }

        return columnsCopy;
    }, [columns]);

    const handleUpdate = async () => {
        try {
            setIsEditing(true);
            const rec = common.convertFormDataToRecord(editData, lovs);

            const { valid, error } = common.validateRecord(rec);

            if (!valid) {
                showMessage(error);
                return;
            }

            onHandleUpdatePressed(rec);
        } catch (error) {
            console.error("Error updating record: " + error);
            showMessage("Error updating record. Please try again.");

        } finally {
            setIsEditing(false);

        }
    }

    return (
        <>
            {showEdit &&
                <Dialog
                    id='edit-dialog'
                    onClose={() => onHandleClose()}
                    open={showEdit}
                    fullWidth={true}
                    maxWidth="lg"
                >

                    {<NewOrEdit
                        rowData={editData}
                        columns={newColumns}
                        changedData={(data) => onHandleChangedData(data)}
                        lovs={lovs} />}


                    <DialogActions>
                        <Button onClick={onHandleClose}>Close</Button>
                        <Button
                            id='update-item-button'
                            onClick={handleUpdate}
                            disabled={isEditing}
                            autoFocus >
                            Update
                        </Button>
                    </DialogActions>

                </Dialog>
            }
        </>
    );


}